import React, { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from "react-router-dom";
import {BsSearch} from 'react-icons/bs';
import { IoIosMenu } from "react-icons/io";
import { GiShoppingCart } from "react-icons/gi";
import { useDispatch, useSelector} from 'react-redux';
import {Typeahead} from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { getAProduct } from '../features/products/productSlice';
import { getAllProducts } from '../features/products/productSlice';
import { getUserCart } from '../features/user/userSlice';

const Header = () => {
  const dispatch = useDispatch()
  const cartState = useSelector(state => state?.auth?.cartProducts)
  const authState = useSelector(state=>state?.auth)
  const productState = useSelector(state => state?.product?.product)
  const [productOpt,setProductOpt]=useState([])
  const [paginate, setPaginate] = useState(true);
  const navigate = useNavigate()
  const [total,setTotal]=useState(null)

  const [brands, setBrands] = useState([])
  const [categories, setCategories] = useState([])
  const [tags, setTags] = useState([])
  // Filter States
  const [tag, setTag] = useState(null)
  const [category, setCategory] = useState(null)
  const [brand, setBrand] = useState(null)
  const [minPrice, setMinPrice] = useState(null)
  const [maxPrice, setMaxPrice] = useState(null)
  const [sort, setSort] = useState(null)

  const getTokenFromLocalStorage = localStorage.getItem('customer')
  ? JSON.parse(localStorage.getItem('customer'))
  : null;

  const config2 = {
    headers: {
      Authorization: `Bearer ${
        getTokenFromLocalStorage !== null ? getTokenFromLocalStorage.token : ''
      }`,
      Accept: 'application/json',
    },
  };

  useEffect(() => {
    dispatch(getUserCart(config2))
  },[])

  useEffect(() => {
    let newBrands = [];
    let category = [];
    let newTags = [];
    let newColors = []
    for (let index = 0; index < productState.length; index++) {
      const element = productState[index];
      newBrands.push(element.brand)
      category.push(element.category)
      newTags.push(element.tags)
      newColors.push(element.color)
    }
    setBrands(newBrands)
    setCategories(category)
    setTags(newTags)
  },[productState])

  useEffect(() => {
    getProducts();
  }, [sort,tag,brand,category,minPrice,maxPrice]);
  const getProducts = () => {
    dispatch(getAllProducts({sort,tag,brand,category,minPrice,maxPrice}));
  };
  

  useEffect(() => {
    let sum = 0
    for (let index = 0; index < cartState?.length; index++) {
      sum = sum + (Number(cartState[index].quantity) * Number(cartState[index].price))
      setTotal(sum)
    }
  },[cartState])
  useEffect(() => {
    let data = []
    for (let index = 0; index < productState.length; index++) {
      const element = productState[index];
      data.push({id:index,prod:element?._id,name:element?.title})
      
    }
    setProductOpt(data)
  },[productState])
  const handleLogout = () => {
    localStorage.clear()
    window.location.reload()
  }
  return (
    <>
      <header className='nav-header' id='header'>
        <div className='nav-upper py-1'>
          <div className='container-fluid'>
            <div className='row align-items-center'>
              <div className='col-2'>
                <div className='nav-logo'>
                  <a rel="Nile" href="https://a-nile.com/" className="nav-a">
                    <svg data-v-fde0c5aa="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" className="iconAbove" aria-hidden="true" focusable="false" width="6em" height="4em"><defs data-v-fde0c5aa=""></defs><rect data-v-fde0c5aa="" fill="transparent" x="0" y="0" width="300px" height="300px" className="logo-background-square"></rect><defs data-v-fde0c5aa=""></defs>
                      <g data-v-fde0c5aa="" id="86a1221b-7f9c-4b4b-ae81-248d0df7c96e" fill="#000000" transform="matrix(2.7057812213897705,0,0,2.7057812213897705,127.60966160198568,165.95385794818253)"><path d="M4.45 14.71L3.39 14.71L2.58 6.30L2.58 6.30Q2.49 6.94 2.40 7.63L2.40 7.63L2.40 7.63Q2.31 8.32 2.18 9.26L2.18 9.26L2.18 9.26Q2.04 10.21 1.86 11.52L1.86 11.52L1.86 11.52Q1.68 12.82 1.41 14.71L1.41 14.71L0.49 14.71L2.10 3.19L3.37 3.19L3.95 11.63L3.95 11.63Q4.00 11.24 4.06 10.84L4.06 10.84L4.06 10.84Q4.12 10.43 4.19 9.93L4.19 9.93L4.19 9.93Q4.26 9.44 4.35 8.82L4.35 8.82L4.35 8.82Q4.44 8.20 4.55 7.40L4.55 7.40L4.55 7.40Q4.66 6.59 4.80 5.56L4.80 5.56L4.80 5.56Q4.94 4.52 5.12 3.19L5.12 3.19L6.06 3.19L4.45 14.71ZM6.55 14.71L5.49 14.71L7.10 3.19L8.16 3.19L6.55 14.71ZM10.74 14.71L7.62 14.71L9.23 3.19L10.29 3.19L8.82 13.66L10.88 13.66L10.74 14.71ZM14.52 14.71L11.40 14.71L13.01 3.19L16.06 3.19L15.90 4.27L13.92 4.27L13.36 8.32L14.76 8.32L14.60 9.38L13.20 9.38L12.60 13.66L14.66 13.66L14.52 14.71Z"></path></g><defs data-v-fde0c5aa=""><linearGradient data-v-fde0c5aa="" gradientTransform="rotate(25)" id="e8619ee0-36ee-4abc-bad4-1e77a0708af1" x1="0%" y1="0%" x2="100%" y2="0%"><stop data-v-fde0c5aa="" offset="0%" stop-color="#041804" stop-opacity="1"></stop><stop data-v-fde0c5aa="" offset="100%" stop-opacity="1"></stop></linearGradient></defs><g data-v-fde0c5aa="" id="1164f2e8-15ad-443e-ac63-cd201a601be2" stroke="none" fill="url(#e8619ee0-36ee-4abc-bad4-1e77a0708af1)" transform="matrix(2.778252601623535,0,0,2.778252601623535,9.234270773395796,-27.651737019373982)"><path d="M52.5 55.563c7 0 11.063-7.688 11.063-7.688s-3.03 4.188-10.5 4.188c-5.438 0-9.75-8.188-20.125-8.188-8.485 0-14.375 8.583-20.826 8.583C8.861 52.458 3.875 48 3.875 48s2.813 7.563 9 7.563c9.625 0 13.313-5.844 20.25-5.844 8.188 0 9.813 5.844 19.375 5.844zm24.667-9.48c-7.323 0-10 7.917-10 7.917s4.322-3.042 9.625-2.167c4.542.75 9.042 6.083 20.667 5.333-4.85-2.15-13.271-11.083-20.292-11.083zm-.542 9.48c-8.688 0-15.537 5.165-22.688 5.063s-9.625-4.5-17.75-4.5c-5.188 0-6.688 5.188-6.688 5.188s1.929-2.25 5.625-2.25c5.188 0 11.058 7.25 19 7.25 12.438 0 17.375-7 22.875-7 4.75 0 10.688 3.75 10.688 3.75s-4.062-7.501-11.062-7.501z"></path></g>
                    </svg>
                  </a>
                </div>
              </div>
              <div className='col-7'>
                <div className="input-group">
                  <Typeahead id="pagination-example" onPaginate={() => console.log('Results paginated')} onChange={(selected) => {navigate(`/product/${selected[0]?.prod}`); dispatch(getAProduct(selected[0]?.prod))}} options={productOpt} paginate={paginate} labelKey={'name'} minLength={2} placeholder="Search Nile..."/>
                  <span className="input-group-text p-3" id="basic-addon2">
                    <BsSearch className='fs-5 text-white'/>
                  </span>
                </div>
              </div>
              <div className='col-3'>
                <div className='header-upper-links d-flex align-items-center gap-10 justify-content-between'>                    
                  <div>
                    <Link to={ authState?.user===null? '/login':'/profile'} className='d-flex align-items-center gap-10 text-dark'>
                      {
                        authState?.user===null ? <p className='mb-0'>Login</p> : <p className='mb-0'>Hello {authState?.user?.firstname}</p>
                      }
                    </Link>
                  </div>
                  <Link to='/signup' className='d-flex align-items-center gap-10 text-dark'>
                    <p className='mb-0'>Account</p>
                  </Link>
                  <div>
                    <Link to='/cart' className='d-flex align-items-center gap-10 text-dark'>
                      <div className='d-flex flex-column gap-10'>
                        <GiShoppingCart style={{height: '40px', width: '50px', position: 'relative'}} />
                        <span className='badge text-red position-absolute'>{cartState?.length ? cartState?.length : 0}</span>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='nav-mainbar py-2'>
          <div className='container-fluid'>
            <div className='row'>
              <div className='col-6'>
                <div className='menu-bottom d-flex align-items-center justify-content-between ps-3 gap-30'>
                  <div className='d-flex gap-10 align-items-center'>
                    <div className='hm-menu'>
                      <div className="dropdown">
                        <button className="btn btn-secondary dropdown-toggle bg-transparent border-1 gap-15 d-flex align-items-center" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                          <IoIosMenu/><span className='me-5 d-inline-block'>All</span>
                        </button>
                        <ul className='dropdown-menu' aria-labelledby="dropdownMenuButton1">
                          {categories && [...new Set(categories)].map((item,index) => {
                            return <li className="dropdown-item text-dark" key={index} onClick={()=>setCategory(item)}>{item}</li>
                          })}
                            <div><button onClick={handleLogout} className='button text-white align-item-center my-1 mx-4' type='submit'>Log Out</button></div>
                        </ul>
                      </div>
                    </div>
                    <div className='menu-bottom d-flex align-items-center gap-30'>
                      <div className='menu-links'>
                        <div className='d-flex align-items-center gap-15'>
                          <NavLink to='/'>Home</NavLink>
                          <NavLink to='/my-orders'>Order</NavLink>
                          <NavLink to='/product'>Store</NavLink>
                          <NavLink to='/wishlist'>Wishlist</NavLink>
                          <NavLink to='/sell'>Sell on Nile</NavLink>
                          <NavLink to='/investor'>Invest in Nile</NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='d-flex align-items-center gap-10'>
                    <div className='select-country'>
                      <select name='' className='form-control form-select bg-transparent' id='' style={{height: "35px"}}>
                        <option value='DEFAULT' selected>Ethiopia</option>
                      </select>
                    </div>
                    <div className='select-language'>
                      <select name='' className='form-control form-select bg-transparent' id='' style={{height: "35px"}}>
                        <option value='DEFAULT' selected>English</option>
                        <option value='' >አማርኛ</option>
                        <option value='title-descending'>Oromo</option>
                      </select>
                    </div>
                    <div className='select-currency'>
                      <select name='' className='form-control form-select bg-transparent' id='' style={{height: "35px"}}>
                        <option value='DEFAULT' selected>ETB</option>
                        <option value='USD' >USD</option>
                      </select>
                    </div>
                  </div> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}

export default Header
